import { useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { WorkflowDTOType } from '../../../schemas/index';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { selectWorkflowFilters, setWorkflowFilters } from '../../../store/workflows/slice';
import { useSearchWorkflowsInfiniteQuery } from '../../../store/workflows/workflowApi';

interface IUseSyncWithUrlProps {
  openProductsDrawer: (workflow: WorkflowDTOType) => void;
  workflows: Array<WorkflowDTOType>;
}

const useSyncWithUrl = ({ openProductsDrawer, workflows }: IUseSyncWithUrlProps) => {
  const location = useLocation();

  const dispatch = useAppDispatch();

  const params = new URLSearchParams(location.search);
  const productsDrawerId = params.get('productsDrawer');

  const workflow = workflows.find(w => String(w.id) === productsDrawerId);

  useEffect(() => {
    if (!productsDrawerId) {
      return;
    }

    if (!workflow) {
      dispatch(
        setWorkflowFilters([
          {
            field: 'id',
            filterType: 'EQ',
            value: productsDrawerId,
          },
        ]),
      );
    }

    if (workflow) {
      openProductsDrawer(workflow);
    }
  }, [productsDrawerId, workflow]);
};

export default useSyncWithUrl;
